module.exports = __webpack_public_path__ + "static/media/paw-icon.d2fc228f.svg";